import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import ProductCard from '@/components/ProductCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Merch = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API}/products`);
        // Filter only T-shirts
        const tshirts = response.data.filter(p => p.name.includes('T-Shirt'));
        setProducts(tshirts);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const filteredProducts = filter === 'all' 
    ? products 
    : filter === 'featured' 
      ? products.filter(p => p.featured)
      : products;

  const categories = ['all', 'featured'];

  return (
    <div data-testid="merch-page" className="min-h-screen bg-white pt-16 md:pt-20">
      {/* Hero Banner */}
      <div className="w-full">
        <img 
          src="https://customer-assets.emergentagent.com/job_9eb43c1b-4d2e-4271-9c32-e74ba97db8fa/artifacts/fj6ruiro_TenomeBanner.jpg"
          alt="Tenome Merch - Wear The Cult - Original Sci-Fi & Horror Apparel"
          className="w-full h-auto object-cover"
        />
      </div>

      <div className="container-custom pt-16 md:pt-20 pb-24">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-black">
            Merch
          </h1>
          <p className="mt-6 text-neutral-500 text-lg max-w-2xl mx-auto">
            Premium cinema-inspired apparel. Each design is a tribute to cult classics and iconic films.
          </p>
        </motion.div>

        {/* Filters */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="flex justify-center gap-4 mb-12"
        >
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              data-testid={`filter-${cat}`}
              className={`px-6 py-2 text-sm font-semibold uppercase tracking-wider transition-all ${
                filter === cat
                  ? 'bg-[#e84628] text-white'
                  : 'bg-transparent text-neutral-400 hover:text-black border border-neutral-200 hover:border-neutral-400'
              }`}
            >
              {cat}
            </button>
          ))}
        </motion.div>

        {/* Product Count */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-center text-neutral-400 text-sm uppercase tracking-wider mb-8"
        >
          {filteredProducts.length} Items
        </motion.p>

        {/* Products Grid */}
        {loading ? (
          <div className="flex justify-center py-20">
            <div className="spinner" />
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
            {filteredProducts.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        )}

        {/* Empty State */}
        {!loading && filteredProducts.length === 0 && (
          <div className="text-center py-20">
            <p className="text-neutral-500 text-lg">No merch items found.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Merch;
